import styled from 'styled-components';
import BestModal from 'react-best-modal';
import type { Props as BestModalProps } from 'react-best-modal/dist/BestModal';
import * as zIndex from 'view/styles/z-index';
import * as transitions from 'view/styles/transitions';
import { SearchBar as Bar, SEARCH_BAR_HEIGHT } from '../search-bar';
import { SearchResult as Result } from '../search-result';
import { TRANSFORM_OPEN_TRANSITION_MS } from '@atlassian/help-center-common-component/expanding-button/styled';
import { MODAL_EXPAND_TRANSITION_MS } from '../styled';
import { token } from '@atlaskit/tokens';
import { colors } from '@atlaskit/theme';

const MODAL_TRANSITION_DELAY_MS = TRANSFORM_OPEN_TRANSITION_MS * 0.5;
export const MODAL_FADE_TRANSITION_MS = TRANSFORM_OPEN_TRANSITION_MS * 0.666;

export const FixedModal = styled<BestModalProps>(BestModal)`
    position: fixed;
    top: 0;
    width: 100%;
    z-index: ${zIndex.modal};
`;

export const FadeInSearchContents = styled.div<transitions.TransitionProps>`
    ${transitions.fadeInOut(MODAL_FADE_TRANSITION_MS)};
    transition-delay: ${(props) => (props.state === 'exiting' ? 0 : MODAL_TRANSITION_DELAY_MS)}ms;
    position: fixed;
    width: 100%;
`;

export const SearchContent = styled.div`
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: ${zIndex.searchBar - 1};
    padding-top: ${SEARCH_BAR_HEIGHT}px;

    /*
        We disable pointer events for the parent container of search
        so we can click through into the blanket to close the modal
     */
    pointer-events: none;
`;

export const SearchBar = styled(Bar)`
    /*
        We reenable pointer events for the children so we can still
        interact with them.
    */
    pointer-events: auto;
    z-index: ${zIndex.searchBar};
    position: fixed;
    width: 100%;
`;

const searchResultHeight = `calc(100% - ${SEARCH_BAR_HEIGHT}px)`;
export const SearchResult = styled(Result)<transitions.TransitionProps>`
    ${transitions.fadeInInstantOut(MODAL_EXPAND_TRANSITION_MS)};
    height: ${searchResultHeight};
    overflow: auto;

    /*
        We reenable pointer events for the children so we can still
        interact with them.
    */
    pointer-events: auto;
`;

export const Background = styled.div<transitions.TransitionProps>`
    ${transitions.slideInOutFromTop(MODAL_EXPAND_TRANSITION_MS)};
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${token('elevation.surface.overlay', colors.N0)};
    opacity: 0.95;
    z-index: ${zIndex.searchBackground};
`;
